export default "__VITE_ASSET__5df7262d__"